import { render } from "./QuantityInputCustom.vue?vue&type=template&id=60f2d94a&scoped=true&ts=true"
import script from "./QuantityInputCustom.vue?vue&type=script&lang=ts"
export * from "./QuantityInputCustom.vue?vue&type=script&lang=ts"

import "./QuantityInputCustom.vue?vue&type=style&index=0&id=60f2d94a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60f2d94a"]])

export default __exports__